import { useMemo } from 'react';

// import { useShifts } from '../../../contexts';
import ScenarioDetailModel, {
  ITableFilterParams,
} from './ScenarioDetail.model';

interface IUseTableDataFilter extends ITableFilterParams {}
export default function useTableData(
  data: any[],
  {
    shiftLength = '',
    providerType = '',
    selectedDay = '',
  }: IUseTableDataFilter = {}
) {
  // const {
  //   state: {
  //     shifts: { data: shiftInfo },
  //   },
  // } = useShifts();
  const tableData = useMemo(() => {
    const scenarioDetail = new ScenarioDetailModel(data);
    // .applyShiftChange(
    //   shiftInfo
    // );
    return {
      rows:
        scenarioDetail.getTableData({
          shiftLength,
          providerType,
          selectedDay,
        }) || [],
      res: scenarioDetail.data,
    };
  }, [data, shiftLength, providerType, selectedDay]);
  return { tableData };
}
